import { render, staticRenderFns } from "./MintNFT.vue?vue&type=template&id=97f44128&"
import script from "./MintNFT.vue?vue&type=script&lang=js&"
export * from "./MintNFT.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports